import redirectSource from './AvatarRedirect';
export default redirectSource('google', 'googleId');